import React from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Permissao } from '../../../../shared/helpers';

const HistoricoPesquisaItem = props => {
    const getPesquisa = log => {
        if (log.base === 'local') {
            let pesquisa = props.guiasPesquisaRx.find(
                g => g.codigo === log.pesquisa,
            );
            return pesquisa ? pesquisa.titulo : '';
        } else if (log.base === 'rede_pergamum') {
            return Permissao.busca(89).descricao;
        } else if (log.base === 'abnt') {
            return Permissao.busca(118).descricao;
        } else if (log.base === 'rede_pergamum_oai') {
            return Permissao.busca(108).descricao;
        }
    };

    const getTermosPesquisa = log => {
        return log.campos.map((campo, i) => {
            return (
                <div key={i} className="inline">
                    <span className="preto70 s15">"{campo.termo}"</span>
                    <span className="preto50 font-italic s14">{` >> ${props.t(
                        campo.option,
                    )}`}</span>
                    {log.campos[i + 1] && (
                        <span className="cortxt f700 l5 r5">/</span>
                    )}
                </div>
            );
        });
    };

    return (
        <Row className="b-w1 b-cinza2 b-solid-top pad10">
            <Col md="1" xs="2" className="txt-right preto70">
                {`${props.indice + 1}.`}
                <Link
                    onClick={props.refazerPesquisa}
                    to={props.item.url}
                    className="btnAzul bkzero b-none rad50p txt-center d-inline-block"
                    title={props.t('RefazerPesquisa')}
                >
                    <FontAwesomeIcon icon="history" className="s14 t10" />
                </Link>
            </Col>
            <Col md="10" xs="8">
                <div className="t5">{getTermosPesquisa(props.item)}</div>
                <div className="l10">
                    <FontAwesomeIcon icon="search" className="s13 cortxt" />
                    <span className="cortxt s13 f500">
                        {' '}
                        {props.t('Pesquisa')}:{' '}
                    </span>
                    <span className="preto70 s13 f400">
                        {getPesquisa(props.item)}
                    </span>
                </div>
                <div className="l10">
                    <FontAwesomeIcon icon="list-ul" className="s13 cortxt" />
                    <span className="preto70 s13 font-italic">
                        {' '}
                        {props.item.registros}{' '}
                        {props.t('registros encontrados')}
                    </span>
                </div>
            </Col>
            <Col md="1" xs="2" className="text-center">
                {props.removerItem && (
                    <button
                        onClick={e => props.removerItem(props.item.id)}
                        className="btn-generic--primeiro nao ml-0"
                        type="button"
                        title={props.t('Remover')}
                    >
                        <FontAwesomeIcon icon="times" className="s14" />
                    </button>
                )}
            </Col>
        </Row>
    );
};

const mapStateToProps = state => ({
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
});

export default connect(mapStateToProps)(HistoricoPesquisaItem);
